@if (active$ | async) {
    <app-wizard-step data-test="step-welcome" [title]="title">
        {{ 'SETUP.STEP_1.SUBTITLE' | translate }}
        <ul>
            <li>{{ 'SETUP.STEP_1.DESCRIPTION' | translate }}</li>
        </ul>
    </app-wizard-step>
}
